import React from "react";
import { useFela } from "react-fela";
import { IWithCustomStyle } from "../../hooks/useTheme/types";
import { useTheme } from "../../hooks/useTheme";

export const BlogText: React.FC<IWithCustomStyle> = ({
  customStyle = {},
  children,
}) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <p
      className={css({
        marginBottom: 29,
        fontSize: 18,
        lineHeight: 1.44,
        letterSpacing: 0.5,
        color: colors.DARK_GREY,
        ...customStyle,
      })}
    >
      {children}
    </p>
  );
};
